module.exports = __webpack_public_path__ + "files/2f51bb59fe7f4afe1f614e8ad431f4c6.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/audio.png
// module id = 410
// module chunks = 76